<template>
	<v-tooltip
		:attach="attach"
		:bottom="bottom"
		:disabled="disabled"
		:left="left"
		:nudge-bottom="nudgeBottom"
		:nudge-right="nudgeRight"
		:nudge-left="nudgeLeft"
		:nudge-top="nudgeTop"
		:right="right"
		:top="top"
		:z-index="zIndex"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<template v-slot:activator="activatorSlotProps">
			<slot
				name="activator"
				v-bind="activatorSlotProps"
			/>
		</template>
		<span v-if="text">{{ text }}</span>
		<slot v-else />
	</v-tooltip>
</template>

<script>
export default {
	name: 'KTooltip',
	inheritAttrs: false,
	props: {
		attach: {
			default: undefined
		},
		bottom: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		left: {
			type: Boolean,
			default: false
		},
		nudgeBottom: {
			type: [Number, String],
			default: 0
		},
		nudgeRight: {
			type: [Number, String],
			default: 0
		},
		nudgeLeft: {
			type: [Number, String],
			default: 0
		},
		nudgeTop: {
			type: [Number, String],
			default: 0
		},
		right: {
			type: Boolean,
			default: false
		},
		top: {
			type: Boolean,
			default: false
		},
		zIndex: {
			type: [Number, String],
			default: undefined
		},
		text: {
			type: String,
			default: undefined
		}
	}
};
</script>